import { Responses } from '../../../../../resources/responses';
import ZoneId from '../../../../../resources/zone_id';
import { RaidbossData } from '../../../../../types/data';
import { TriggerSet } from '../../../../../types/trigger';

export type Data = RaidbossData;

const triggerSet: TriggerSet<Data> = {
  id: 'TheNavel',
  zoneId: ZoneId.TheNavel,
  timelineFile: 'titan-nm.txt',
  timelineTriggers: [
    {
      // Early Callout for Tank Cleave
      id: 'TitanNm Rock Buster',
      regex: /Rock Buster/,
      beforeSeconds: 5,
      response: Responses.tankCleave(),
    },
  ],
  triggers: [
    {
      id: 'TitanNm Tumult',
      type: 'Ability',
      netRegex: { id: '282', source: 'Titan', capture: false },
      suppressSeconds: 2,
      response: Responses.aoe(),
    },
    {
      // Gaol callout for both yourself and others
      id: 'TitanNm Gaols',
      type: 'GainsEffect',
      netRegex: { effectId: '124' },
      alertText: (data, matches, output) => {
        if (matches.target !== data.me)
          return output.breakGaolOn!({ player: data.party.member(matches.target) });

        return output.gaolOnYou!();
      },
      outputStrings: {
        breakGaolOn: {
          en: 'Break Gaol on ${player}',
          de: 'Zerstöre das Gefängnis von ${player}',
          fr: 'Brisez la geôle sur ${player}',
          ja: '${player}にジェイル',
          cn: '石牢点${player}',
          ko: '${player} 돌감옥 해제',
          tc: '石牢點${player}',
        },
        gaolOnYou: {
          en: 'Gaol on YOU',
          de: 'Gefängnis auf DIR',
          fr: 'Geôle sur VOUS',
          ja: '自分にジェイル',
          cn: '石牢点名',
          ko: '돌감옥 대상자',
          tc: '石牢點名',
        },
      },
    },
  ],
  timelineReplace: [
    {
      'locale': 'de',
      'replaceSync': {
        'Earthen Fury': 'Gaias Zorn',
        'Titan': 'Titan',
      },
      'replaceText': {
        'Earthen Fury': 'Gaias Zorn',
        'Geocrush': 'Geo-Stoß',
        'Landslide': 'Bergsturz',
        'Rock Buster': 'Steinsprenger',
        'Rock Throw': 'Granitgefängnis',
        'Tumult': 'Urerschütterung',
        'Weight Of The Land': 'Gaias Gewicht',
      },
    },
    {
      'locale': 'fr',
      'replaceSync': {
        'Earthen Fury': 'Fureur tellurique',
        'Titan': 'Titan',
      },
      'replaceText': {
        'Earthen Fury': 'Fureur tellurique',
        'Geocrush': 'Broie-terre',
        'Landslide': 'Glissement de terrain',
        'Rock Buster': 'Casse-roc',
        'Rock Throw': 'Jeté de rocs',
        'Tumult': 'Tumulte',
        'Weight Of The Land': 'Poids de la terre',
      },
    },
    {
      'locale': 'ja',
      'replaceSync': {
        'Earthen Fury': '大地の怒り',
        'Titan': 'タイタン',
      },
      'replaceText': {
        'Earthen Fury': '大地の怒り',
        'Geocrush': 'ジオクラッシュ',
        'Landslide': 'ランドスライド',
        'Rock Buster': 'ロックバスター',
        'Rock Throw': 'グラナイト・ジェイル',
        'Tumult': '激震',
        'Weight Of The Land': '大地の重み',
      },
    },
    {
      'locale': 'cn',
      'replaceSync': {
        'Earthen Fury': '大地之怒',
        'Titan': '泰坦',
      },
      'replaceText': {
        'Earthen Fury': '大地之怒',
        'Geocrush': '大地粉碎',
        'Landslide': '地裂',
        'Rock Buster': '碎岩',
        'Rock Throw': '花岗岩牢狱',
        'Tumult': '怒震',
        'Weight Of The Land': '大地之重',
      },
    },
    {
      'locale': 'tc',
      'replaceSync': {
        'Earthen Fury': '大地之怒',
        'Titan': '泰坦',
      },
      'replaceText': {
        'Earthen Fury': '大地之怒',
        'Geocrush': '大地撞擊',
        'Landslide': '地裂',
        'Rock Buster': '岩石破壞者',
        'Rock Throw': '花崗岩牢獄',
        'Tumult': '激震',
        'Weight Of The Land': '大地重壓',
      },
    },
    {
      'locale': 'ko',
      'replaceSync': {
        'Earthen Fury': '대지의 분노',
        'Titan': '타이탄',
      },
      'replaceText': {
        'Earthen Fury': '대지의 분노',
        'Geocrush': '대지 붕괴',
        'Landslide': '산사태',
        'Rock Buster': '바위 쪼개기',
        'Rock Throw': '화강암 감옥',
        'Tumult': '격진',
        'Weight Of The Land': '대지의 무게',
      },
    },
  ],
};

export default triggerSet;
